import { SCENARIO_VARIATION_LIST_DATA } from "../../../constants/closeLoop/scenarioGroup/expandableScenarioComponentConstants";

const defaultScenarioVariationInfo = {
    scenarioVariationData: [],
    pages: [],
    currentPage: 0,
};

export const scenarioVariationInfoReducer = (state = defaultScenarioVariationInfo, action) => {
    switch (action.type) {
        case SCENARIO_VARIATION_LIST_DATA:
            return {
                scenarioVariationData: action.scenarioVariationData,
                currentPage: action.currentPage,
                pages: action.pages,
            };
        default:
            return state;
    }
};
